/** Returns the public explorer URL for a supported UTXO transaction. */
export function getUtxoTransactionUrl(chain: string, transactionHash: string): string | null {
  if (chain === 'BTC') {
    return `https://mempool.space/tx/${transactionHash}`
  }
  if (chain === 'LTC') {
    return `https://litecoinspace.org/tx/${transactionHash}`
  }
  if (chain === 'BCH') {
    return `https://blockchair.com/bitcoin-cash/transaction/${transactionHash}`
  }
  return null
}
